export const CREDIT_RESTORATION_QUIZ_ENTRY_STEPS_TITLES = [
    'Complete a simple questionnaire to help us better understand your needs',
    'Answer a few simple questions to verify who you are',
    'View your credit score and get personalized options to help you improve your credit',
];
